export { default } from '@telexpress_auth/vue-vms';
